module.exports = __webpack_public_path__ + "media/images/lb/283-526c9f08bc4663d0ffed9d99eaa21957.svg";